<template>
  <svg
    aria-hidden="true"
    width="9"
    height="15"
    viewBox="0 0 9 15"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.13281 7.5L7.69141 7.94141L1.44141 14.1914L1 14.6328L0.117188 13.75L0.558594 13.3086L6.36719 7.5L0.558594 1.69141L0.117188 1.25L1 0.367188L1.44141 0.808594L7.69141 7.05859L8.13281 7.5Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'refapp-beforeafter-thumbnail-arrow',
};
</script>
